import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-info",
  "use": "svg_i-info-usage",
  "viewBox": "0 0 4 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 11\" id=\"svg_i-info\"><path d=\"M0 5.994V3.996h3v4.995h1v1.998H0V8.99h1V5.994H0ZM0 1.503C0 1.09.146.736.44.442A1.442 1.442 0 0 1 1.5 0c.42 0 .775.148 1.065.442.29.295.435.648.435 1.06 0 .413-.146.765-.44 1.057a1.448 1.448 0 0 1-1.06.438c-.408 0-.76-.147-1.056-.442A1.436 1.436 0 0 1 0 1.503Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol